
import { Form, Lead } from "@/types";
import DashboardHeader from "./DashboardHeader";
import DashboardStatistics from "./DashboardStatistics";
import AchievementBadges from "./AchievementBadges";
import FormsSection from "./FormsSection";
import LeadsSection from "./LeadsSection";
import AIInsights from "./AIInsights";
import { UserProfile } from "@/types";
import { Achievement } from "@/hooks/useAchievementBadges";

interface DashboardContentProps {
  isLoading: boolean;
  forms: Form[];
  recentLeads: Lead[];
  userProfile: UserProfile | null;
  achievements: Achievement[];
  earnedCount: number;
  totalCount: number;
  initialBadgesCompleted: boolean;
}

const DashboardContent = ({ 
  isLoading, 
  forms, 
  recentLeads, 
  userProfile,
  achievements,
  earnedCount,
  totalCount,
  initialBadgesCompleted
}: DashboardContentProps) => {
  return (
    <div className="page-transition bg-background text-foreground">
      <DashboardHeader isLoading={isLoading} userProfile={userProfile} />
      
      <DashboardStatistics 
        isLoading={isLoading} 
        forms={forms} 
        recentLeads={recentLeads} 
      />

      <div className="mb-8 w-full">
        <AchievementBadges 
          achievements={achievements}
          earnedCount={earnedCount}
          totalCount={totalCount}
          initialBadgesCompleted={initialBadgesCompleted}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 w-full">
        <FormsSection forms={forms} isLoading={isLoading} />
        <LeadsSection 
          recentLeads={recentLeads} 
          isLoading={isLoading} 
          forms={forms} 
        />
      </div>
      
      <AIInsights forms={forms} leads={recentLeads} />
    </div>
  );
};

export default DashboardContent;
